import { useEffect, useRef, useState } from "react";
import { checkForNewVersion } from "../lib/appVersion";
import NewVersionModal from "./NewVersionModal";

// Резервната проверка, докато прозорецът стои отворен и никой не го напуска.
const CHECK_INTERVAL_MS = 60 * 60 * 1000;

// SPA-то продължава да изпълнява стария bundle в отворения прозорец до пълно
// презареждане на документа — logout/login са `navigate()` и не помагат.
// Затова питаме сървъра за версията (при старт, при всяко връщане на фокус и
// веднъж на час) и при разлика показваме модал с бутон „Презареди".
// `checkForNewVersion` връща разликата чак когато новият service worker е
// свалил билда — презареждането веднага след това е от първия път.
// Екраните без отворена работа (ПИН, /login) не чакат човек — там
// `useReloadOnNewVersion` презарежда сам.
export default function VersionCheckNotifier() {
  const [hasNewVersion, setHasNewVersion] = useState(false);
  const alreadyNotifiedRef = useRef(false);
  // Проверката може да чака новия worker до минута — връщане на фокус
  // междувременно не пуска втора.
  const isCheckingRef = useRef(false);

  useEffect(() => {
    const checkAndNotify = async () => {
      if (alreadyNotifiedRef.current || isCheckingRef.current) return;
      isCheckingRef.current = true;
      try {
        const serverVersion = await checkForNewVersion();
        if (!serverVersion) return;
        alreadyNotifiedRef.current = true;
        setHasNewVersion(true);
      } finally {
        isCheckingRef.current = false;
      }
    };

    // Веднага при монтиране: часовникът тръгва от нулата и без това първата
    // проверка би закъсняла с цял час; хваща и прозорец, възстановен от
    // браузъра със стар документ.
    void checkAndNotify();
    const onVisibilityChange = () => {
      if (document.visibilityState === "visible") void checkAndNotify();
    };
    document.addEventListener("visibilitychange", onVisibilityChange);
    const intervalId = setInterval(() => void checkAndNotify(), CHECK_INTERVAL_MS);
    return () => {
      document.removeEventListener("visibilitychange", onVisibilityChange);
      clearInterval(intervalId);
    };
  }, []);

  return <NewVersionModal open={hasNewVersion} />;
}
